import script from "./confluence-permission-less.vue?vue&type=script&setup=true&lang=js"
export * from "./confluence-permission-less.vue?vue&type=script&setup=true&lang=js"

import "./confluence-permission-less.vue?vue&type=style&index=0&id=f796ce8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f796ce8e"]])

export default __exports__